
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import TableDisplay from '../../TableDisplay/TableDisplay';
import ContainerEntryForm from './ContainerForm';
import axios from 'axios';
import { useAuth } from '../../../context/AuthContext';
import { formatDateTime12hr } from '../../../utils/DateFormater';
import { getMaterialNames } from '../../../utils/reSolveMaterial';
import { useOptions } from "../../../hooks/useOptions";
import { toast } from 'react-toastify';
import { X, Pencil } from 'lucide-react';
import FilterForm from '../../../utils/FilterForm';
import { calculateDemurrage } from '../../../utils/DemurrageUtil';
// import Select from 'react-select/base';
import { Mail } from 'lucide-react';
import { useTheme } from '../../../context/ThemeContext';
import { useConfirm } from '../../../context/ConfirmContext';
const CLIENT_PAGE_SIZE = 50;
const SERVER_PAGE_SIZE = 50;

export default function ContainerEntry() {
    const { isDark, theme } = useTheme();
    const { confirm } = useConfirm();
    const [rows, setRows] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isEditFormOpen, setIsEditFormOpen] = useState(false);
    const [editingContainer, setEditingContainer] = useState(null);
    const [currentServerPage, setCurrentServerPage] = useState(1);
    const [loadedServerPages, setLoadedServerPages] = useState(new Set());
    const { permissions } = useAuth();
    const [filterData, setFilterData] = useState({});
    
    const {
      material: materialOptions,
      status,
      refresh,
      loading: optionsLoading
    } = useOptions();
    const [showAddForm, setShowAddForm] = useState(false);
    const columns = useMemo(() => [
        { key: "ContainerId", label: "Container Id", sortable: true },
        { key: "Container", label: "Container No", sortable: true, filterable: true },
        { key: "Supplier", label: "Supplier" },
        { key: "ArrivalDate", label: "Arrival Date", sortable: true },
        { key: "EmptyAt", label: "Empty At" },
        { key: "Demurrage", label: "Demurrage", sortable: true},

        { 
            key: "Status", 
            label: "Status",
            type: "select",
            filterable: true ,
            options: status.map(item => item.name),
            cellClassName: (value) => 
                value === "On port" ? 'bg-blue-500' : 
                value === "Gate Pass" ? 'bg-green-500' : ''
        },
        { key: "Material", label: "Materials", filterable: true},
        { key: "Consignee", label: "Consignee" }
    ], [status]);
    // console.log(status)



    useEffect(() => {
        if (materialOptions.length > 0 && rows.length) 
        {
            setRows(prev =>
            prev.map(r => ({
                ...r,
                Material: getMaterialNames(r.rawData.materials, materialOptions)
            }))
            );
        }
    }, [materialOptions]);

    const transformData = useCallback((apiData) => {
        if (!apiData) return [];
        // console.log(apiData);
        
        return apiData.map(c => ({
            ContainerId: c.Container_ID,
            Container: c.container_no || "",
            Consignee: c.bill_of_landing?.consignee_name || "",
            Supplier: c.bill_of_landing?.supplier_name || "",
            Demurrage: c.bill_of_landing?.ArrivalDate &&  c.state !== "In Transit" ? calculateDemurrage({
                ExcludeDayBitmask: c.bill_of_landing.ExcludingDay, 
                ArrivalDate: c.bill_of_landing.ArrivalDate, 
                FreeDay: c.FreeDays !== null && c.FreeDays !== undefined ? c.FreeDays : c.bill_of_landing.FreeDays 
            }) : "",
            ArrivalDate: c.bill_of_landing?.ArrivalDate 
                ? formatDateTime12hr(c.bill_of_landing.ArrivalDate.slice(0, 16)) 
                : "",
            EmptyAt: c.location || "",
            Status: c.state || "",
            Material: getMaterialNames(c.materials, materialOptions),
            vessal: null,
            rawData: c // Store raw data for editing
        }));
    }, [materialOptions]);

    const getIdByName = (name) => {
        const found = status.find(item => item.name === name);
        return found ? found.id : null;
    };
    const fetchData = useCallback(async (
        offset = 0,
        limit = SERVER_PAGE_SIZE,
        filters = filterData
        ) => {
        const pageNum = Math.floor(offset / limit) + 1;
        if (loadedServerPages.has(pageNum)) return;

        const statusOrder = [7, 6, 3, 2, 1, 8];


        
        try {
            const searchParams = new URLSearchParams();

            searchParams.append("offset", offset);
            searchParams.append("limit", limit);

            if (filters.Container) searchParams.append("container_no", filters.Container);
            if (filters.Supplier) searchParams.append("SupplierName", filters.Supplier);
            if (filters.Consignee) searchParams.append("ConsigneeName", filters.Consignee);
            if (filters.Status) {
            searchParams.append("status", getIdByName(filters.Status));
            } else {
            searchParams.append("excStatus", 4);
            }
            if (filters.Material) searchParams.append("material", filters.Material);

            if (statusOrder?.length) {
            statusOrder.forEach(id => searchParams.append("status_order", id)); // ✅ Repeats key without []
            }
            searchParams.append("order_by_arrival", false);
        setIsLoading(true);
        const response = await axios.get(
            `${process.env.REACT_APP_NETWORK}/containers?${searchParams.toString()}`,
            {
            
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                "skip_zrok_interstitial": "true",
            },
            
            }
        );

        const { data, total_count } = response.data;
        
        const transformedData = transformData(data);
        console.log(transformedData)
        for (const i of transformedData){
        console.log( i.Status);

        }
        // console.log(typeof transformData.Demurrage);
        if (totalItems !== total_count) {
            setTotalItems(total_count);
        }
        // console.log(transformedData);
        setRows(prev => {
            const newRows = [...prev];
            for (let i = 0; i < transformedData.length; i++) {
            newRows[offset + i] = transformedData[i];
            }
            return newRows;
        });

        setLoadedServerPages(prev => new Set(prev).add(pageNum));
        } catch (error) {
        console.error("Failed to fetch containers:", error);
        } finally {
        setIsLoading(false);
        }
    }, [transformData, totalItems, loadedServerPages]);
    
    function handleFilterSubmit(col, val) {
        const newFilters = { [col]: val };

        // console.log("Applied Filters:", newFilters);

        setFilterData(newFilters);
        setLoadedServerPages(new Set());
        setRows([]);
        fetchData(0, SERVER_PAGE_SIZE, newFilters);
    }
    
    const handlePageChange = useCallback((newClientPage, itemsPerPage) => {
        const startIndex = (newClientPage - 1) * itemsPerPage;
        const endIndex = newClientPage * itemsPerPage;
        
        // Calculate which server pages we need
        const firstNeededPage = Math.floor(startIndex / SERVER_PAGE_SIZE) + 1;
        const lastNeededPage = Math.floor((endIndex - 1) / SERVER_PAGE_SIZE) + 1;
        
        // Fetch any missing pages
        for (let page = firstNeededPage; page <= lastNeededPage; page++) {
            if (!loadedServerPages.has(page)) {
               fetchData(page, SERVER_PAGE_SIZE);
            }
        }
        
        setCurrentServerPage(firstNeededPage);
        console.log("Page change")
    }, [fetchData, loadedServerPages]);


    const handleEdit = useCallback((row) => {
        setEditingContainer(row.rawData);
        setIsEditFormOpen(true);
    }, []);

    const handleDelete = useCallback(async (containerId) => {
        // console.log(containerId);
        setIsEditFormOpen(!isEditFormOpen);
        const isConfirmed = await confirm("Are you sure you want to delete this container?");
        if (!isConfirmed) return;
        
        try {
            await axios.delete(
                `${process.env.REACT_APP_NETWORK}/containers/${containerId}`,
                { headers: { Authorization: `Bearer ${localStorage.getItem('token')}`,
                    "skip_zrok_interstitial": "true"
                 },
                }
            );
            
            // Invalidate cache and reload
            setLoadedServerPages(new Set());
            setRows([]);
            fetchData(0, SERVER_PAGE_SIZE);
        } catch (error) {
            console.error("Failed to delete container:", error);
            toast.error("Failed to delete container");
        }
    }, [fetchData]);

    const handleEditFormClose = useCallback(() => {
        setIsEditFormOpen(false);
        setEditingContainer(null);
    }, []);

    const handleEditFormSubmitSuccess = useCallback(() => {
        setLoadedServerPages(new Set());
        setRows([]);
        fetchData(0, SERVER_PAGE_SIZE);
        handleEditFormClose();
    }, [fetchData, handleEditFormClose]);

   
    const actionColumn = useMemo(() => ({
        render: (row) => (
            <div className="flex justify-center">
                {permissions.includes('Edit_Container') && (
                    <button 
                        onClick={() => handleEdit(row)} 
                        className="text-blue-500 hover:text-blue-700 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded p-1"
                        title="Edit container"
                    >
                        <Pencil size={18} />
                    </button>
                )}
            </div>
        )
    }), [permissions]);



    const handlePickupEmail = async () => {


        try {
        const response = await axios.get(`${process.env.REACT_APP_NETWORK}/toPickup`, {
            headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "skip_zrok_interstitial": "true",
            },
            
            // 👈 pass as query parameter
        });

        const containers = response.data;

        if (!containers.length) {
            toast.info("No arrived containers found.");
            return;
        }

        const subject = "Pickup Request for Arrived Containers";
        let body = "Please arrange pickup for the following containers:\n\n";

        containers.forEach((c, i) => {

                body += `${i + 1}. Container: ${c.container_no}\n   Location: ${c.venue}\n   Arrival: ${c.emptyDate}\n\n`;

        });

        const mailto = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = mailto;

        } catch (err) {
        console.error("Failed to fetch container data:", err);
        toast.error("Error fetching container data.");
        }
    };
    
    const handleDropoffEmail = async () => {


        try {
        const response = await axios.get(`${process.env.REACT_APP_NETWORK}/arrived`, {
            headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "skip_zrok_interstitial": "true",
        
            
            }, 
            withCredentials: false
            // 👈 pass as query parameter
        });

        const containers = response.data;

        if (!containers.length) {
            toast.info("No containers found to drop.");
            return;
        }

        const subject = "DropOff Request for Arrived Containers";
        let body = "Please arrange pickup for the following containers:\n\n";

        containers.forEach((c, i) => {
            body += `${i + 1}. Container: ${c.container_no}\n   Location: ${c.venue}\n   Arrival: ${c.arrival_on_port}\n\n`;
        });

        const mailto = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = mailto;

        } catch (err) {
        console.error("Failed to fetch container data:", err);
        toast.error("Error fetching container data.");
        }

    };
    
    useEffect(() => {
        // console.log("Material",materialOptions);
        if (!optionsLoading && materialOptions.length > 0) {
             fetchData(0, SERVER_PAGE_SIZE);
        }
    }, [optionsLoading, materialOptions, fetchData]);
    
    const filterPopup = (
        
        <FilterForm
        columns={columns}
        userPermissions={permissions}
        handleFilterChange={handleFilterSubmit}
        />
    );
    // console.log(permissions)
   return (
        <div className={`flex flex-col w-full h-full  ${
        theme.background
      }`}>
            <TableDisplay 
                key="container-table"
                columns={columns} 
                data={rows}
                totalItems={totalItems}
                title="Container"
                onDataChange={() => {
                    setLoadedServerPages(new Set());
                    fetchData(0, SERVER_PAGE_SIZE);
                }}
                userPermissions={permissions}
                add
                // actionColumn={actionColumn}
                itemsPerPage={CLIENT_PAGE_SIZE}
                serverPageSize={SERVER_PAGE_SIZE}
                isLoading={isLoading || optionsLoading}
                onPageChange={handlePageChange}
                addDataComponent={
                    <ContainerEntryForm                        
                        userPermissions={permissions}
                    />
                }
                addButtonText="Add Container"
                theme={theme}
                onRowClick={(row) => {permissions.includes('Edit_Container') && handleEdit(row)}}
                addButtonPermission="Add_Container"
                filterPopup={filterPopup}
                emptyStateComponent={
                    <div className="py-8 text-center">
                        <p className="text-gray-500 dark:text-slate-300">No containers found</p>
                        {permissions.includes('Add_Container') && (
                            <button
                                onClick={() => setShowAddForm(true)}
                                className="mt-4 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded transition-colors"
                            >
                                Add New Container
                            </button>
                        )}
                    </div>
                }

                getRowClassName={(row) => {
                    if (isDark) {
                        if (row.Demurrage.includes("Overdue")){
                            return 'hover:bg-red-450 bg-red-400 text-red-50'
                        }else{
                            // console.log(row.Demurrage.includes("Overdue"))
                        switch (row.Status) {
                            case 'Unloaded':
                                return 'hover:bg-yellow-800 bg-yellow-900 text-yellow-100';
                            case 'In Transit':
                                return 'hover:bg-slate-800 bg-slate-900 text-slate-200';
                            case 'On port':
                                return 'hover:bg-blue-800 bg-blue-900 text-blue-100';
                            case 'Gate Pass':
                                return 'hover:bg-green-800 bg-green-900 text-green-100';
                            case 'Arrived':
                                return 'hover:bg-indigo-800 bg-indigo-900 text-indigo-100';
                            default:
                                return 'hover:bg-slate-800 bg-slate-900 text-slate-200';
                        }
                        }

                    } else {
                        if (row.Demurrage.includes("Overdue")){
                            return 'hover:bg-red-450 bg-red-400 text-red-50'
                        }else{
                        switch (row.Status) {
                            case 'Unloaded':
                                return 'hover:bg-yellow-50 bg-yellow-200 text-yellow-900';
                            case 'In Transit':
                                return `hover:bg-gray-100 bg-white ${theme.text}`;
                            case 'On port':
                                return 'hover:bg-blue-50 bg-blue-200 text-blue-900';
                            case 'Gate Pass':
                                return 'hover:bg-green-50 bg-green-200 text-green-900';
                            case 'Arrived':
                                return 'hover:bg-indigo-50 bg-indigo-200 text-indigo-900';
                            default:
                                return `hover:bg-gray-100 bg-white ${theme.text}`;
                        }
                    }}
                }}

                extraButton={{
                    button: <div className="flex items-center gap-1"><Mail/> </div>,
                    title: "Mail",
                    content: (
                        <>
                        
                            <button
                                onClick={handlePickupEmail}
                                className="w-full bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 mb-2"
                            >
                                Pick Up
                            </button>
                            <button
                                onClick={handleDropoffEmail}
                                className="w-full bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                            >
                                Drop Off
                            </button>
                        </>
                    )
                }}

            />

            {/* Edit Form Modal */}
            {isEditFormOpen && (

                <div className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 `}>
                    <div className={`rounded-lg w-full max-w-2xl max-h-[90vh] flex flex-col border-2 ${
                        theme.background

                        } ${theme.border} shadow-lg overflow-hidden`}>
                        <div className="flex justify-between items-center p-4 border-b">
                        <h3 className="text-lg font-semibold">{editingContainer ? "Edit Container" : "Add New Item"}</h3>
                        <button onClick={handleEditFormClose}><X /></button>
                        </div>
                        <div className={`overflow-y-auto px-4 pb-0 pt-4 ${theme.scrollbar}`} style={{ maxHeight: 'calc(90vh - 64px)' }}>
                         <ContainerEntryForm 
                             editData={editingContainer}
                             onSubmitSuccess={handleEditFormSubmitSuccess}
                             onCancel={handleEditFormClose}
                             userPermissions={permissions}
                             handleDeleteFunction={handleDelete}
                         />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}